import { computed, ref, watch } from '@vue/composition-api';
import useTaxiTransaction from '@/modules/taxi/composables/useTaxiTransaction';
import useUtils from '@/composables/useUtils';

const useTaxiTransactionsHistoryList = (props) => {
  const { fetchTaxiTransactions  } = useTaxiTransaction();
  const { formatDateYyyyMmDd, convertDateToUTC } = useUtils();

  const perPageOptions = [10, 25, 50, 100];
  const tableColumns = [
    { key: 'id', label: '#', sortable: true },
    { key: 'transactionStatusId', label: 'Status' },
    { key: 'companyId', label: 'Company', sortable: true },
    { key: 'accountId', label: 'Account', sortable: true },
    { key: 'bookingId', label: 'Booking', sortable: true },
    { key: 'postId', label: 'Post', sortable: true },
    { key: 'tourId', label: 'Tour', sortable: true },
    { key: 'amount', sortable: true },
    { key: 'transactionDateUtc', label: 'Date', sortable: true },
    { key: 'actions' },
  ];

  const pageNumber = ref(1);
  const orderDesc = ref(true);
  const pageSize = ref(10);
  const refTransactionList = ref(null);
  const orderBy = ref('id');
  const totalTansactions = ref(0);

  const transactionStatusFilter = ref(
    localStorage.getItem('taxiTransactionHistory-transactionStatusFilter') == 'null'
      ? null
      : JSON.parse(localStorage.getItem('taxiTransactionHistory-transactionStatusFilter'))
  );
  const searchQuery = ref(
    localStorage.getItem('taxiTransactionHistory-searchQuery') == ''
      ? ''
      : localStorage.getItem('taxiTransactionHistory-searchQuery')
  );
  const searchByDate = ref(
    localStorage.getItem('taxiTransactionHistory-searchByDate') == ''
      ? ''
      : localStorage.getItem('taxiTransactionHistory-searchByDate')
  );

  const dataMeta = computed(() => {
    const localItemsCount = refTransactionList.value
      ? refTransactionList.value.localItems.length
      : 0;
    return {
      from: pageSize.value * (pageNumber.value - 1) + (localItemsCount ? 1 : 0),
      to: pageSize.value * (pageNumber.value - 1) + localItemsCount,
      of: totalTansactions.value,
    };
  });

  watch(
    [pageNumber, pageSize, transactionStatusFilter, searchByDate],
    () => {
      localStorage.setItem(
        'taxiTransactionHistory-transactionStatusFilter',
        JSON.stringify(transactionStatusFilter.value)
      );
      localStorage.setItem(
        'taxiTransactionHistory-searchByDate',
        searchByDate.value
      );
      refTransactionList.value.refresh();
    }
  );

  const refreshTable = () => {
    localStorage.setItem(
        'taxiTransactionHistory-searchQuery',
        searchQuery.value
      );
    refTransactionList.value.refresh();
  };

  const clearSearchByDate = () => {
    searchByDate.value = '';
  };

  const getTransactionList = (_, callback) => {
    const params = {
      orderBy: orderBy.value,
      orderDesc: orderDesc.value,
      searchByDate: searchByDate.value === '' ? null : formatDateYyyyMmDd(convertDateToUTC(searchByDate.value)),
      pageSize: pageSize.value,
      pageNumber: pageNumber.value,
      transactionStatusId: transactionStatusFilter.value?.id ?? undefined,
      searchQuery: searchQuery.value,
    };

    fetchTaxiTransactions (props.taxiId, params).then(
      ({ transactions, total }) => {
        callback(transactions);
        totalTansactions.value = total;
      }
    );
  };

  return {
    // Const
    perPageOptions,
    tableColumns,

    // Reactive
    orderBy,
    orderDesc,
    pageNumber,
    pageSize,
    refTransactionList,
    searchQuery,
    transactionStatusFilter,
    totalTansactions,
    searchByDate,

    // Computed
    dataMeta,

    // Method
    getTransactionList,
    clearSearchByDate,
    refreshTable
  };
};

export default useTaxiTransactionsHistoryList;
